@if (deleteMsg) {
<div>
  @if (success) { suppression OK! :
  <p>{{ deleteMsg }}</p>
  } @else { Echec de suppression. Détails:
  <p [innerHtml]="deleteMsg | replaceLineBreaks">{{ deleteMsg }}</p>
  }
</div>
}
